import { useI18n, type Composer } from 'vue-i18n'

const translations = {
  'pt-br': {
    StoreOverview: 'Visão geral',
    StoreSettings: 'Configuração',
    StorePersonalization: 'Personalização',
    StoreOrderModes: 'Modos de pedidos',
    StorePayments: 'Pagamentos',
    StoreProducts: 'Produtos',
    PaymentsAccount: 'Minha Conta',
    PaymentsStatement: 'Extrato',
    PaymentsReceipts: 'Recebimentos',
    PaymentsAnticipation: 'Antecipação',
    PaymentsPaymentLink: 'Link de Pagamento',
    PaymentsSimulator: 'Simulador de vendas',
    PaymentsDevices: 'Maquininhas'
  },
  en: {
    StoreOverview: 'Overview',
    StoreSettings: 'Settings',
    StorePersonalization: 'Personalization',
    StoreOrderModes: 'Order modes',
    StorePayments: 'Payments',
    StoreProducts: 'Products',
    PaymentsAccount: 'My account',
    PaymentsStatement: 'Statement',
    PaymentsReceipts: 'Incoming payments',
    PaymentsAnticipation: 'Anticipation',
    PaymentsPaymentLink: 'Payment link',
    PaymentsSimulator: 'Sales simulator',
    PaymentsDevices: 'Card machines'
  },
  es: {
    StoreOverview: 'Resumen',
    StoreSettings: 'Configuración',
    StorePersonalization: 'Personalización',
    StoreOrderModes: 'Modos de pedido',
    StorePayments: 'Pagos',
    StoreProducts: 'Productos',
    PaymentsAccount: 'Mi cuenta',
    PaymentsStatement: 'Extracto',
    PaymentsReceipts: 'Cobros',
    PaymentsAnticipation: 'Anticipo',
    PaymentsPaymentLink: 'Link de pago',
    PaymentsSimulator: 'Simulador de ventas',
    PaymentsDevices: 'Maquinitas'
  }
}

export function useComingSoonProductMenusTranslation (): Composer<typeof translations> {
  const i18n = useI18n()

  try {
    for (const [key, values] of Object.entries(translations)) {
      i18n.mergeLocaleMessage(key, values)
    }
  } catch {
    /* empty */
  }

  return useI18n({ messages: translations })
}
